import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

const skin = era.skin('widgets/Popups/MotnStreamingOptionsPopup/')

MotnStreamingOptionsPopup.displayName = 'MotnStreamingOptionsPopup'
export function MotnStreamingOptionsPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='motnStreamingOptionsPopup' />
}
